import { render, staticRenderFns } from "./AppVersionCheck.vue?vue&type=template&id=56568f40"
import script from "./AppVersionCheck.vue?vue&type=script&lang=js"
export * from "./AppVersionCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports